<template>
  <Modal v-model="temuExecuteShipmentModal" :title="$t('key1006241')" class-name="temuExecuteShipmentStyle" width="1000" :transfer="false"
    :mask-closable="false" @on-visible-change="temuExecuteShipmentChange">
    <h2 class="title">{{ $t('key1006435') }}</h2>
    <div class="table_box mb20">
      <Table
        :highlight-row="false"
        :disabled-hover="true"
        border
        max-height="500"
        :span-method="handleSpan"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <h2 class="title red-dot">{{ $t('key1006436') }}</h2>
    <Input v-model.trim="logisticsOrderNo" clearable :placeholder="$t('key1006434')" style="width: 350px;"></Input>
    <template #footer>
      <Button @click="temuExecuteShipmentModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="temuExecuteShipmentBtn" :disabled="tableData.length<=0">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "temuExecuteShipmentModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      logisticsOrderNo: '',
      temuExecuteShipmentModal: false,
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'orderNumber',
          minWidth: 120,
          align: 'left'
        },
        {
          title: 'SKU',
          key: 'sku',
          width: 100,
          align: 'left',
          render: (h, params) => {
            return h('span', params.row._productInfo.ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          key: 'specifications',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let spec = '';
            if (params.row._productInfo.productGoodsSpecificationList) {
              spec = params.row._productInfo.productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
              return h('p', {
                class: 'color-green'
              }, spec);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          width: 90,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006427'),
          key: 'transferCode',
          width: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006428'),
          key: 'userWeight',
          width: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006429'),
          key: 'totalPackagesNumber',
          width: 110,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          width: 110,
          render(h, params) {
            let orderType = params.row.orderType;
            let packagingLabelName = params.row.packagingLabelName;
            let packageTalg = params.row.packageTalg;
            /*订单是发货订单，单品单件和多品多件需要上传标签。如果是样品订单，单品单件不需要上传标签*/
            if ((orderType === 'TEMU_P') || (orderType === 'TEMU_S' && !packageTalg)) {
              return !packagingLabelName ? h('Upload', {
                props: {
                  name: "files",
                  headers: v.headObj,
                  maxSize: v.uploadFilesMaxSize,
                  onExceededSize: v.uploadExceedSize,
                  showUploadList: false,
                  onSuccess: (response, file, fileList) => v.uploadSuccess(response, file, fileList, params.index),
                  onFormatError: (file, fileList) => v.handleFormatError(file, fileList),
                  onError: v.uploadFilesError,
                  action: v.fileApi
                }
              }, [
                h('p', {
                  style: {
                    color: '#02A6EF',
                    cursor: 'pointer'
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006430'))
              ]) : h('div', {class: 'flex align-items-center'}, [
                h('span', {
                  style: {
                    width: '120px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  },
                  attrs: {
                    title: packagingLabelName
                  },
                }, packagingLabelName),
                h('Icon', {
                  props: {
                    type: 'md-close',
                    size: 16
                  },
                  style: {
                    cursor: 'pointer',
                    color: '#E8250B',
                    marginLeft: '5px',
                    fontWeight: 'bold'
                  },
                  on: {
                    click: () => {
                      setTimeout(() => {
                        v.$set(v.tableData[params.index], 'packagingLabelName', '');
                        v.$set(v.tableData[params.index], 'packagingLabelUrl', '');
                        v.$forceUpdate();
                      }, 500);
                    }
                  }
                })
              ]);
            } else {
              return h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006431'));
            }
          }
        }
      ],
      tableData: [],
      platformOrderImplementShipmentsList: [],
      ymsThirdPlatformPackageList: []
    };
  },
  methods: {
    // 初始化数据
    initTemuExecuteShipmentData(data) {
      let v = this;
      if (data.length > 0) {
        let ymsPlatformOrderIds = [];
        data.map((item) => {
          ymsPlatformOrderIds.push(item.ymsPlatformOrderId);
        });
        if (ymsPlatformOrderIds.length > 0) {
          v.axios.post(api.post_ymsPlatformOrder_queryDetailByIds, ymsPlatformOrderIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              let ymsPlatformAccountIds = [];
              if (data && data.length > 0) {
                data.map((item) => {
                  ymsPlatformAccountIds.push(item.ymsPlatformAccountId);
                });
                if (ymsPlatformAccountIds.length > 0) {
                  v.getStoreCode(data, ymsPlatformAccountIds);
                }
              }
            }
          });
        }
      }
    },
    // 根据ymsPlatformAccountId获取对应店铺的code
    getStoreCode(data, ymsPlatformAccountIds) {
      let v = this;
      if (ymsPlatformAccountIds.length > 0) {
        v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountByIds, ymsPlatformAccountIds).then(response => {
          if (response.data.code === 0) {
            let datas = response.data.datas;
            if (datas) {
              datas.map((item) => {
                data.map((ele) => {
                  if (ele.ymsPlatformAccountId === item.ymsPlatformAccountId) {
                    ele.storeCode = item.code;
                    ele.orderNumber = ele.storeCode + '-' + ele.platformOrderNo;
                  }
                });
              });
              v.handleData(data);
              v.temuExecuteShipmentModal = true;
            }
          }
        });
      }
    },
    // 包裹的数据
    handleData(data) {
      let v = this;
      if (data && data.length > 0) {
        let list = [];
        let newData = [];
        data.map((item) => {
          item['goodsData'] = v.handleGoodsData(item);
          let ymsPlatformOrderPackageRelateds = item.ymsPlatformOrderPackageRelateds || [];
          if (ymsPlatformOrderPackageRelateds.length > 0) {
            ymsPlatformOrderPackageRelateds.map((ele) => {
              let ymsThirdPlatformPackages = ele.ymsPackageInfo ? ele.ymsPackageInfo.ymsThirdPlatformPackages || [] : [];
              if (ymsThirdPlatformPackages.length > 0) {
                ymsThirdPlatformPackages.map((talg) => {
                  let ymsThirdPlatformPackageGoods = talg.ymsThirdPlatformPackageGoods || [];
                  if (ymsThirdPlatformPackageGoods.length > 0) {
                    talg.totalPackagesNumber = ymsThirdPlatformPackageGoods.reduce(
                      (pre, cur) => {
                        return pre + cur.quantity;
                      }, 0);
                    talg.ymsPlatformOrderId = item.ymsPlatformOrderId;
                    talg.packageCode = ele.packageCode;
                    talg.orderNumber = item.orderNumber;
                    talg.orderType = item.orderType;
                    talg['goodsData'] = JSON.parse(JSON.stringify(item['goodsData']));
                    v.ymsThirdPlatformPackageList.push(talg);
                    newData.push(talg);
                  }
                });
              }
            });
          }
        });
        v.platformOrderImplementShipmentsList = data;
        let transferCodeList = v.uniqueFunc(newData, 'transferCode');
        if (transferCodeList.length > 0) {
          transferCodeList.map((j) => {
            let ymsThirdPlatformPackageGoods = j.ymsThirdPlatformPackageGoods;
            ymsThirdPlatformPackageGoods.map((k, index) => {
              k.orderNumber = j.orderNumber;
              k.totalPackagesNumber = j.totalPackagesNumber;
              k.ymsPackageId = j.ymsPackageId;
              k.userWeight = j.userWeight;
              k.transferCode = j.transferCode;
              k.ymsPlatformOrderId = j.ymsPlatformOrderId;
              k.packagingLabelUrl = '';
              k.packagingLabelName = '';
              k.orderType = j.orderType;
              k.ymsThirdPlatformPackageId = j.ymsThirdPlatformPackageId;
              k.packageTalg = ymsThirdPlatformPackageGoods.length === 1;
              k['length'] = ymsThirdPlatformPackageGoods.length;
              k['currentTalg'] = (ymsThirdPlatformPackageGoods.length > 1 && index === 0);
              let goodsData = JSON.parse(JSON.stringify(j['goodsData']));
              k['goodsData'] = goodsData;
              if (goodsData.length > 0) {
                k['orderLength'] = goodsData.length;
              }
              list.push(k);
            });
          });
        }

        let newList = v.uniqueFunc(list, 'ymsThirdPlatformPackageGoodsId');
        let ymsProductGoodsIds = [];
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
            let ymsThirdPlatformPackageGoodsId = item.goodsData[0].ymsThirdPlatformPackageGoodsId;
            if (item.ymsThirdPlatformPackageGoodsId === ymsThirdPlatformPackageGoodsId) {
              item['orderIndex'] = index;
            }
            ymsProductGoodsIds.push(item.ymsProductGoodsId);
          });
          if (ymsProductGoodsIds.length > 0) {
            (async () => {
              v.tableData = await v.getProductInfoByIds(ymsProductGoodsIds, newList);
            })();
          }
        }
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      // 订单号行合并
      let orderColumnList = [0];
      if (orderColumnList.includes(columnIndex)) {
        if (row.orderLength > 1) {
          if (rowIndex === row.orderIndex) {
            return [row.orderLength, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }

      let columnList = [4, 5, 6, 7];
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 获取一个订单里面所有小包的所有货品数据
    handleGoodsData(obj) {
      let list = [];
      let ymsPlatformOrderPackageRelateds = obj.ymsPlatformOrderPackageRelateds || [];
      if (ymsPlatformOrderPackageRelateds.length > 0) {
        ymsPlatformOrderPackageRelateds.map((ele) => {
          let ymsThirdPlatformPackages = ele.ymsPackageInfo ? ele.ymsPackageInfo.ymsThirdPlatformPackages || [] : [];
          if (ymsThirdPlatformPackages.length > 0) {
            ymsThirdPlatformPackages.map((talg) => {
              let ymsThirdPlatformPackageGoods = talg.ymsThirdPlatformPackageGoods || [];
              if (ymsThirdPlatformPackageGoods.length > 0) {
                ymsThirdPlatformPackageGoods.map((j) => {
                  list.push(j);
                });
              }
            });
          }
        });
      }
      return list;
    },
    // 确定按钮
    temuExecuteShipmentBtn() {
      let v = this;
      let query = {
        platformOrderImplementShipmentsBos: [],
        trackingNumber: v.logisticsOrderNo,
        deliveryGroup: '',
        deliveryName: '',
        ymsLogisServiceId: null
      };
      v.platformOrderImplementShipmentsList.map((item) => {
        query.platformOrderImplementShipmentsBos.push({
          ymsPlatformOrderId: item.ymsPlatformOrderId,
          ymsThirdPlatformPackageBos: []
        });
      });
      let newList = v.uniqueFunc(v.ymsThirdPlatformPackageList, 'ymsThirdPlatformPackageId');
      if (newList.length > 0) {
        // 按小包进行分组
        let packagingData = v.handerGrouping(v.tableData, function (item) {
          return [item.transferCode];
        }, 'transferCode');
        if (packagingData.length > 0) {
          for (let i = 0; i < packagingData.length; i++) {
            let item = packagingData[i];
            for (let j = 0; j < item.data.length; j++) {
              let ele = item.data[j];
              if ((ele.orderType === 'TEMU_P') || (ele.orderType === 'TEMU_S' && !ele.packageTalg)) {
                let talg = item.data.some((k) => {
                  return k.packagingLabelUrl;
                });
                if (!talg) {
                  v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006432'));
                  return false;
                }
              }
            }
          }
        }
        if (!query.trackingNumber) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006433'));
          return false;
        }
        newList.map((item) => {
          packagingData.map((ele) => {
            if (item.transferCode === ele.transferCode) {
              let labelPathList = ele.data.filter((talg) => {
                return talg.packagingLabelUrl !== '';
              });
              item.labelPath = labelPathList.length > 0 ? labelPathList[0].packagingLabelUrl : null;
            }
          });
        });
        query.platformOrderImplementShipmentsBos.map((item) => {
          newList.map((ele) => {
            if (item.ymsPlatformOrderId === ele.ymsPlatformOrderId) {
              item.ymsThirdPlatformPackageBos.push({
                labelPath: ele.labelPath,
                ymsThirdPlatformPackageId: ele.ymsThirdPlatformPackageId
              });
            }
          });
        });
        v.axios.put(api.put_ymsPlatformOrder_implementShipment, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006242'));
            v.temuExecuteShipmentModal = false;
            v.$emit('updateData', true);
          }
        });
      }
    },
    // 上传打包标签成功
    uploadSuccess(response, file, fileList, currentIndex) {
      let v = this;
      if (response.code === 0) {
        let imgUrl = response.datas[0];
        let name = file.name;
        v.$set(v.tableData[currentIndex], 'packagingLabelUrl', imgUrl);
        v.$set(v.tableData[currentIndex], 'packagingLabelName', name);
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
        v.$forceUpdate();
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
      }
    },
    // 验文件格式
    handleFormatError() {
      let v = this;
      v.$Message.error({
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005661'),
        duration: 5
      });
      return false;
    },
    // 监听弹窗
    temuExecuteShipmentChange(value) {
      if (!value) {
        this.platformOrderImplementShipmentsList = [];
        this.ymsThirdPlatformPackageList = [];
        this.logisticsOrderNo = '';
        this.tableData = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .temuExecuteShipmentStyle {
  .title {
    color: #333;
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0;
  }
}
</style>